/** Normaliza respuesta paginada del API o array legacy. */
export function normalizePaginatedResponse(data) {
  if (Array.isArray(data)) {
    return { results: data, total: data.length, page: 1, page_size: data.length };
  }
  return {
    results: Array.isArray(data?.results) ? data.results : [],
    total: typeof data?.total === 'number' ? data.total : 0,
    page: data?.page ?? 1,
    page_size: data?.page_size ?? 20,
  };
}
